<template>
  <div class="sc-weather-widget">
    <r-icon :name="currentWeather.icon" :size="24" />
    <r-text>
      {{ $t(`weather-widget:type-${currentWeather.name}`) }},
      {{ currentWeather.temp }}°
    </r-text>
  </div>
</template>

<script>
export default {
  props: {
    currentWeather: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.sc-weather-widget {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  > div {
    margin-right: 8px;
    &:last-child {
      margin-right: 0;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "weather-widget:type-Thunderstorm": "Гроза",
    "weather-widget:type-Drizzle": "Морось",
    "weather-widget:type-Rain": "Дождь",
    "weather-widget:type-Snow": "Снег",
    "weather-widget:type-Clear": "Безоблачно",
    "weather-widget:type-Clouds": "Облачно",

    "weather-widget:type-Mist": "Туман",
    "weather-widget:type-Smoke": "Дымка",
    "weather-widget:type-Haze": "Мгла",
    "weather-widget:type-Dust": "Пыль",
    "weather-widget:type-Fog": "Туман",
    "weather-widget:type-Sand": "Калима",
    "weather-widget:type-Ash": "Зола",
    "weather-widget:type-Squall": "Шквал",
    "weather-widget:type-Tornado": "Ураган"
  },
  "en": {
    "weather-widget:type-Thunderstorm": "Thunderstorm",
    "weather-widget:type-Drizzle": "Drizzle",
    "weather-widget:type-Rain": "Rain",
    "weather-widget:type-Snow": "Snow",
    "weather-widget:type-Clear": "Clear sky",
    "weather-widget:type-Clouds": "Clouds",

    "weather-widget:type-Mist": "Mist",
    "weather-widget:type-Smoke": "Smoke",
    "weather-widget:type-Haze": "Haze",
    "weather-widget:type-Dust": "Dust",
    "weather-widget:type-Fog": "Fog",
    "weather-widget:type-Sand": "Sand",
    "weather-widget:type-Ash": "Ash",
    "weather-widget:type-Squall": "Squall",
    "weather-widget:type-Tornado": "Tornado"
  }
}
</i18n>
